<template>
    <v-form ref="form_datos_generales">
        <v-container fluid grid-list-md>
            <v-row dense>
                <v-col cols="12" sm="4">
                    <v-text-field label="Contratante " color="textbox" v-model="objForm.nombreContratante" outlined dense
                        readonly />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field label="Ruc " color="textbox" v-model="objForm.numeroDocumento" outlined dense readonly />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field label="Razón Social " color="textbox" v-model="objForm.nombreComercial" outlined dense
                        readonly />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" sm="4">
                    <v-text-field label="Objeto Especial (Actividad Económica) *" color="textbox"
                        v-model="objForm.actEconomica"
                        :rules="_.concat(requeridoRegla,soloLetrasRegla(1,objForm.actEconomica,500))" outlined dense />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field label="Teléfono Celular " color="textbox" v-model="objForm.telefonoCelular"
                        v-mask="'###-###-####'" outlined dense readonly />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field label="Email" color="textbox" v-model="objForm.email" outlined dense readonly />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" sm="6">
                    <v-text-field label="País" color="textbox" v-model="objForm.pais" outlined dense readonly />
                </v-col>
                <v-col cols="12" sm="6">
                    <v-text-field label="Provincia" color="textbox" v-model="objForm.provincia" outlined dense readonly />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" sm="4">
                    <v-text-field label="Cantón" color="textbox" v-model="objForm.canton" outlined dense readonly />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field label="Parroquia" color="textbox" v-model="objForm.parroquia" outlined dense readonly />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field label="Sector" color="textbox" v-model="objForm.sector" outlined dense readonly />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" sm="12">
                    <v-text-field label="Dirección" color="textbox" v-model="objForm.direccion" outlined dense readonly />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" sm="12" class="mt-3 mb-3 text-right">
                    <v-btn rounded dark color="primary" @click="next('objDatosGenerales',objForm)">Siguiente</v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-form>
</template>

<script>
    import { mask } from 'vue-the-mask';
    export default {
        name: 'StepperDatoGeneralComponent',
        directives:{mask},
        inject:['next'],
        props:{
            cargar:{
                type:Boolean,
                default: false
            },
            objForm:{
                type:Object,
                default:{}
            },
            listGeneral:{
                type:Object,
                default:{}
            },
            parametros:{
                type:Object,
                default:{}
            }
        }
    }
</script>